import { useSignInLogPage } from 'src/hooks/signInLog';
import { notification } from 'src/components/Notification';
import { usePageChanged } from 'src/hooks/utils';

export default ({ userId }) => {
  try {
    const { data, refetch, loading, fetchMore, variables } = useSignInLogPage({
      userId,
      limit: 15,
      offset: 0,
      q: '',
      orderBy: 'created_at',
      orderDirection: 'desc',
    });
    const onPageChanged = usePageChanged(fetchMore, '');
    return [
      {
        data:
          (data && {
            items: data.signInLogs,
            pageInfo: data.signInLogsPageInfo,
          }) ||
          {},
        loading,
        refetch,
        variables,
        defaultSearch: '',
      },
      { onPageChanged },
    ];
  } catch (e) {
    notification.error(e);
    return [{ data: [], loading: false }, {}];
  }
};
